module.exports = __webpack_public_path__ + "static/media/powerbi.1ad0ce4f.svg";